import React from 'react'
import injectSheet from 'react-jss'
import ReactSlider from 'rc-slider'
import '!style-loader!css-loader!rc-slider/assets/index.css'

const styles = theme => ({
  slider: {
    '& .rc-slider-track': {
      backgroundColor: theme.colors.primaryLight
    },
    '& .rc-slider-dot-active': {
      borderColor: theme.colors.primaryLight
    },
    '& .rc-slider-handle': {
      borderColor: theme.colors.primaryLight
    },
    '& .rc-slider-handle:hover': {
      borderColor: theme.colors.primaryDark
    },
    '& .rc-slider-handle:focus': {
      boxShadow: {
        spread: 5,
        color: theme.colors.primaryLight,
      }
    },
    '& .rc-slider-handle:active': {
      borderColor: theme.colors.primaryDark,
      boxShadow: {
        blur: 5,
        color: theme.colors.primary
      }
    }
  }
})

const Slider = ({ classes, ...props }) => <ReactSlider {...props} className={classes.slider} />
Slider.propTypes = ReactSlider.propTypes

export default injectSheet(styles)(Slider)
